// The name each billing interval goes by in the subscription editor, by the interval as the backend stores it: the
// editor's tabs and the plan modal's toggle.
const c_BillingIntervalLabels = {
	month: 'Monthly',
	year: 'Annual'
};

// The name of a billing interval, the interval itself for one without a name.
export const get_billing_interval_label = (billing_interval)=>{
	return c_BillingIntervalLabels[billing_interval] ? c_BillingIntervalLabels[billing_interval] : billing_interval;
};
